import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { projectKeys } from '../projectKeys'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useDeleteProjectPermitTemplate = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['deleteProjectPermitTemplate']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...projectKeys.deleteProjectPermitTemplate,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(
        projectKeys.byId({ projectId: variables.projectId })._ctx
          .projectPermitTemplates._def,
      )
    },
  })
}
